import React, { forwardRef, useState } from "react";
import {
  Card,
  Radio,
  Space,
  Button,
  Collapse,
  Modal,
  Tooltip,
  Typography,
} from "antd";
import {
  DownloadOutlined,
  QuestionCircleOutlined,
  FrownTwoTone,
} from "@ant-design/icons";

import { ListDalleMnX } from "./listDalleMns"

import { ListDalleMnh } from "./listDalleMnh"

import { ListDalleMnt } from "./listDalleMnt"

import { handleTelechargement } from "../utils/utilsMenu";
import DownloadComponent from "./DownloadComponent";
import ModalComponent from "./Modal/Modal";



const MenuWrapper = forwardRef(function MenuWrapper(props, ref) {

  const { isDalleDisplay, selectedMode, setInteractionMode, dalleMNX } = props

  const handleTelechargementAll = () => {

    // variable qui aura le contenu
    let contenu = "";
    // ajout de chaque dalle dans le contenu du txt
    dalleMNX.forEach((dalle) => {
      contenu += dalle.mns.url + "\n";
    });
    dalleMNX.forEach((dalle) => {
      contenu += dalle.mnh.url + "\n";
    });
    dalleMNX.forEach((dalle) => {
      contenu += dalle.mnt.url + "\n";
    });


    handleTelechargement(contenu, process.env.REACT_APP_DOWNLOAD_FILE_NAME_ALL)

  }
  const handleTelechargementMns = () => {

    // variable qui aura le contenu
    let contenu = "";
    // ajout de chaque dalle dans le contenu du txt
    dalleMNX.forEach((dalle) => {
      contenu += dalle.mns.url + "\n";
    });


    handleTelechargement(contenu, process.env.REACT_APP_DOWNLOAD_FILE_NAME_MNS)

  }

  const handleTelechargementMnh = () => {

    // variable qui aura le contenu
    let contenu = "";
    // ajout de chaque dalle dans le contenu du txt
    dalleMNX.forEach((dalle) => {
      contenu += dalle.mnh.url + "\n";
    });


    handleTelechargement(contenu, process.env.REACT_APP_DOWNLOAD_FILE_NAME_MNH)

  }
  const handleTelechargementMnt = () => {

    // variable qui aura le contenu
    let contenu = "";
    // ajout de chaque dalle dans le contenu du txt
    dalleMNX.forEach((dalle) => {
      contenu += dalle.mnt.url + "\n";
    });


    handleTelechargement(contenu, process.env.REACT_APP_DOWNLOAD_FILE_NAME_MNT)

  }


  const items_collapse_liste_produit = [

    {
      key: '1',
      label: 'Liste des MNS',
      children: <ListDalleMnX dalleMNX={dalleMNX}></ListDalleMnX>,
      extra: <DownloadComponent title="Télécharger la liste des liens des MNS" handleTelechargement={handleTelechargementMns}></DownloadComponent>

    },
    {
      key: '2',
      label: 'Liste des MNH',
      children: <ListDalleMnh dalleMNX={dalleMNX}></ListDalleMnh>,
      extra: <DownloadComponent title="Télécharger la liste des liens des MNH" handleTelechargement={handleTelechargementMnh}></DownloadComponent>
    },
    {
      key: '3',
      label: 'Liste des MNT',
      children: <ListDalleMnt dalleMNX={dalleMNX}></ListDalleMnt>,
      extra: <DownloadComponent title="Télécharger la liste des liens des MNT" handleTelechargement={handleTelechargementMnt}></DownloadComponent>
    },
  ];




  return (<>
    <div className="menu">
      <div className="menu-interface">
        <Space align="center">
          <Tooltip title="Accéder à la page de téléchargement des nuages de points LiDAR HD">
            <Button href="/">Nuages de points</Button>
          </Tooltip>

          <Button href="/MNX/" className="clicked-button" type="default" >Produits dérivés</Button>
        </Space>
      </div>
      {isDalleDisplay ? (

        <div className="menu_mode">
          <Typography.Paragraph className="center">
            Sélectionnez les dalles qui vous intéressent puis téléchargez la liste des liens pour les récupérer. <br />
          </Typography.Paragraph>
          <Card title="Choix du mode de sélection">
            <Space
              direction="vertical"
              style={{ width: "100%" }}
              size="large"
            >
              <Radio.Group
                onChange={e => setInteractionMode(e.target.value)}
                value={selectedMode.actifMode}
              >
                <Radio value={"click"}>Clic</Radio>
                <Radio value={"polygon"}>Polygone</Radio>
                <Radio value={"rectangle"}>Rectangle</Radio>
              </Radio.Group>
            </Space>
          </Card>

        </div>
      ) :
        <Space>
          <Typography.Paragraph className="center">
            Cette interface vous permet de visualiser les données disponibles dans votre zone d'intérêt et de récupérer une liste de liens pour les télécharger. <DownloadOutlined style={{fontSize:25}}/><br/><br/>
            <Typography.Text strong="true">
              Cliquez sur la zone d'intérêt souhaitée pour consulter les données disponibles.<br/><br/>
            </Typography.Text>
          </Typography.Paragraph></Space>}
      <div className="dalle-select">
        {dalleMNX.length === 0 ? (
          null
        ) : (
          <React.Fragment>
            <Collapse items={items_collapse_liste_produit}></Collapse>
          </React.Fragment>
        )}
      </div>
      {dalleMNX.length > 0 ? (
        <div className="center">
          <Space>
            <Button
              onClick={handleTelechargementAll}
              type="primary"
              icon={<DownloadOutlined />}
              size="large"
            >
              Télécharger la liste des liens
            </Button>

            <ModalComponent></ModalComponent>


          </Space>
        </div>
      ) : null}
    </div>


  </>
  );
})

export default MenuWrapper